export const GettingStartedData = {
  headingDetail: {
    title: "Getting Started",
    description:
      "Whether you are trying to get attention of college coaches, or local travel teams in your area, it is important for athletes to build an appealing profile. Follow these easy steps to ensure that you are being noticed by some of the best coaches all around the nation."
  },
  features: [
    {
      icon: "user.svg",
      image: ["http://topnotch.demo-4u.com/img/college-info.ec9929f4.png"],
      title: "Complete Your Profile",
      description:
        "Fill in all the information about you like basic information (name, colllege, age, battling hand, throwing hand, preferred position etc.), academic information like graduation year,high school, GPA."
    },
    {
      icon: "video-camera.svg",
      image: ["http://topnotch.demo-4u.com/img/chat-ss.da06c785.png"],
      title: "Upload Good Quality Videos",
      description:
        "College coaches watch hours of video from recruits, so you need to make yours stand out and count. Some coaches may want detailed skills videos and limited in-game footage. Others may only want to see your in-game skills.Upload Good Nally Videos by using youtube and vimeo."
    },
    {
      icon: "info.svg",
      image: ["http://topnotch.demo-4u.com/img/player-search.5a519b4b.jpg"],
      title: "Upload Additional Information",
      description:
        "Post additional information like game schedules,social media links, team played in the past etc."
    },
    {
      icon: "search.svg",
      image: ["http://topnotch.demo-4u.com/img/event-search.a0582e22.jpg"],
      title: "Search For College and Clubs",
      description:
        "To be successful during the recruiting process, you must carefully hand-select colleges that are right for you."
    },
    {
      icon: "visibility.svg",
      image: ["http://topnotch.demo-4u.com/img/college-search.53a10346.png"],
      title: "View College and Club Details",
      description:
        "The NCAA bases academic eligibility on your high school coursework, grades and standardized test scores."
    },
    {
      icon: "chat-icon.svg",
      image: ["http://topnotch.demo-4u.com/img/chat-ss.da06c785.png"],
      title: "Chat with the college and club coaches",
      description:
        "Communicate with a coach at least once a month to strengthen your cause and develop your relationship."
    }
  ]
};

export const CoachSpecificData = {
  headingDetail: {
    title: "Coach Specific Features",
    description:
      "Last but not least, Don't just sit around and wait for coaches to find you. Take a PROACTIVE approach by taking advantage of some of oue great features."
  },
  features: [
    {
      icon: "hourglass.svg",
      stepImage: "time",
      title: "Enjoy Free Trial for a certain time",
      description:
        "A campus visit is an essential component of determining which college is right for you."
    },
    {
      icon: "users.svg",
      stepImage: "profiles",
      title: "Manage all your profiles under same login",
      description:
        "A highlight video is a great way to distinguish yoursefl and convince a coach to come see You play."
    },
    {
      icon: "group.svg",
      stepImage: "profiles",
      title: "See who is viewing your profile",
      description:
        "Unless you're one of the top athletes in the country, don't expect a team to give you a full athletic scholarship."
    },
    {
      icon: "star.svg",
      stepImage: "star",
      title: "Create List of Your Favourites",
      description:
        "A campus visit is an essential component of determining which college is right for you."
    },
    {
      icon: "event.svg",
      stepImage: "events",
      title: "Search for college and club events",
      description:
        "A highlight video is a great way to distinguish yoursefl and convince a coach to come see you play."
    },
    {
      icon: "loupe.svg",
      stepImage: "search",
      title: "Advanced Search Fields",
      description:
        "Unless you're one of the top athletes in the country, don't expect a team to give you a full athletic scholarship."
    }
  ]
};

export const GreatFeaturesData = {
  headingDetail: {
    title: "Great Features",
    description:
      "Last but not least, Don't just sit around and wait for coaches to find you. Take a PROACTIVE approach by taking advantage of some of oue great features."
  },
  features: [
    {
      icon: "hourglass.svg",
      stepImage: "time",
      title: "Enjoy Free Trial for a certain time",
      description:
        "A campus visit is an essential component of determining which college is right for you."
    },
    {
      icon: "users.svg",
      stepImage: "profiles",
      title: "Manage all your profiles under same login",
      description:
        "A highlight video is a great way to distinguish yoursefl and convince a coach to come see You play."
    },
    {
      icon: "group.svg",
      stepImage: "profiles",
      title: "See who is viewing your profile",
      description:
        "Unless you're one of the top athletes in the country, don't expect a team to give you a full athletic scholarship."
    },
    {
      icon: "star.svg",
      stepImage: "star",
      title: "Create List of Your Favourites",
      description:
        "A campus visit is an essential component of determining which college is right for you."
    },
    {
      icon: "event.svg",
      stepImage: "events",
      title: "Search for college and club events",
      description:
        "A highlight video is a great way to distinguish yoursefl and convince a coach to come see you play."
    },
    {
      icon: "loupe.svg",
      stepImage: "search",
      title: "Advanced Search Fields",
      description:
        "Unless you're one of the top athletes in the country, don't expect a team to give you a full athletic scholarship."
    }
  ]
};
